const initialState = {
    code: '',
    disabledBtn: true,
    isLoading: false,
    btnClass: 'disable-btn', 
    temporaryToken: false,
    showReferalPage: false,
};
const referal = (state = initialState, action) => {
    switch (action.type) {
        case 'CHANGE_INPUT_PAGE_REFERAL':
           return {...state, [action.name]: action.value};
        case 'CHANGE_TIMER_TIME_PAGE_REFERAL':
            return {...state, timer_time: action.timer_time};
        case 'CHANGE_DISABLED_BTN_PAGE_REFERAL':
            return {...state, disabledBtn: action.disabledBtn};
        case 'CHANGE_LOADER_PAGE_REFERAL':
            return {...state, isLoading: action.isLoading};
        case 'CHANGE_BTN_CLASS_PAGE_REFERAL':
           return {...state, btnClass: action.className};
        default:
            return state;
    }
};

export default referal;
